import React from "react";

export function NoteIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.33337 13.3333C7.33337 12.9651 7.63185 12.6666 8.00004 12.6666H14C14.3682 12.6666 14.6667 12.9651 14.6667 13.3333C14.6667 13.7015 14.3682 14 14 14H8.00004C7.63185 14 7.33337 13.7015 7.33337 13.3333Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.0001 2.58577C11.8018 2.58577 11.6117 2.66453 11.4715 2.80473L3.2687 11.0075L2.9163 12.4171L4.32589 12.0647L12.5287 3.86192C12.5981 3.7925 12.6531 3.71009 12.6907 3.6194C12.7283 3.5287 12.7476 3.43149 12.7476 3.33332C12.7476 3.23515 12.7283 3.13794 12.6907 3.04725C12.6531 2.95655 12.5981 2.87414 12.5287 2.80473C12.4592 2.73531 12.3768 2.68025 12.2861 2.64268C12.1954 2.60511 12.0982 2.58577 12.0001 2.58577ZM10.5286 1.86192C10.9189 1.47168 11.4482 1.25244 12.0001 1.25244C12.2733 1.25244 12.5439 1.30626 12.7964 1.41084C13.0488 1.51541 13.2782 1.66869 13.4715 1.86192C13.6647 2.05514 13.818 2.28454 13.9225 2.537C14.0271 2.78947 14.0809 3.06006 14.0809 3.33332C14.0809 3.60659 14.0271 3.87718 13.9225 4.12964C13.818 4.3821 13.6647 4.6115 13.4715 4.80473L5.13813 13.1381C5.05269 13.2235 4.94563 13.2841 4.82841 13.3134L2.16175 13.9801C1.93456 14.0369 1.69424 13.9703 1.52865 13.8047C1.36306 13.6391 1.2965 13.3988 1.35329 13.1716L2.01996 10.505C2.04927 10.3877 2.10988 10.2807 2.19532 10.1953L10.5286 1.86192Z"
      />
    </svg>
  );
}
